import { loadAndMigrateState, Migrator } from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { migrateRassePyrenaeen } from './2_migrate_rasse_pyrenaeen';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 2,
    migratorFunction: migrateRassePyrenaeen,
  },
];

export const loadAndMigrateTkvState = (
  currentState: IAppState,
  loadedState: { version: number },
) => loadAndMigrateState(currentState, loadedState, stateMigrators);
